<template>
    <div>        
        <v-select :label="optionsLabel" append-to-body :options="options" :value="selectedValue" :filterable="false" @input="setSelected" :searchable="false" :clearable="false" v-bind="$attrs"></v-select>
    </div>
</template>
<script>
export default {
    props: ["model", "name", "selected", "errorMessage", "options", "state", "isEditable", "optionsLabel", "optionsKey", "change", "label", "isRequired", "onSelectMethod", "isSelectMethodExists", "itemData"],
    data() {
        return {
            labelStr: this.label,
            value:"",
            selectedValue: this.selected,
            inputModel: this.model,
            groupId : "fieldset-" + name,
            feedbackId : "input-" + name + "-live-feedback",
        }
    }, 
    methods: {
        setSelected(value) {
            if (!this.isSelectMethodExists) {
                this.inputModel = value != null ? value[this.optionsKey] : null;
                this.selectedValue = value != null ? value[this.optionsLabel] : null;
                this.$emit('update:model', this.inputModel);
                this.$emit("change");
            } else {
                this.$emit("onSelectMethod", value, this.itemData);
            }
        },
        // searchData(search, loading) {
        //     this.$emit("input", search);
        // }
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        }
    },
    watch: {
        model(newValue) {
            this.inputModel = newValue;
            if (newValue == null || newValue == '') {
                this.selectedValue = '';
            }
        },
        selected(newValue) {
            this.selectedValue = newValue;
        }
    }
}
</script>
<style lang="scss" scoped>
.input-group-text {
    font-size: 0.7rem !important;
}
:deep .vs__dropdown-toggle {
    background: #ffffff !important;
}
</style>